enum DiscountType {
  TAX = 'vat',
  DUTY = 'duty',
}

export default DiscountType;
